
import { Component, Vue } from 'vue-property-decorator';
import { productTypeListPC, productTypeList } from '@/services/http';

@Component({
  name: 'DropDown'
})
export default class extends Vue {
  // 分类列表
  productTypeList: [] = []

  // 分类列表子分类
  productTypeChildren: any[] = []

  created() {
    this.getProductTypeList();
  }

  private async getProductTypeList() {
    const res: any = await productTypeListPC({
      companyId: 1
    });
    this.productTypeList = res.data.data;
  }

  private async dropdownClick(productTypeId: number) {
    const res: any = await productTypeList({
      productTypeId,
      companyId: 1
    });
    if (res.data.code === 100) {
      this.productTypeChildren = res.data.data.children;
    }
  }

  private goDetails(productTypeId: string) {
    window.location.href = `/classify?productTypeId=${productTypeId}`;
  }
}
